import React from 'react'
import PropTypes from 'prop-types'
import { nanoid } from 'nanoid'

function PatientPDIContentTableRow(props) {
  const { tableContent } = props
  return (
    <tr>
      { tableContent.map(content => (
        <td key={ nanoid() }>
          { content }
        </td>
      ))}
    </tr>
  )
}

PatientPDIContentTableRow.propTypes = { tableContent: PropTypes.array }

PatientPDIContentTableRow.defaultProps = { tableContent: [] }

export default PatientPDIContentTableRow
